<!-- 顶部导航栏 -->
<template>
  <div class="Topbar">
    <div class="tools">
      <div class="tools_item" v-for="(item, index) in tabs"
        :key="index" @click="toView(item)" :style="index===(tabs.length-1)?'margin-right: 50px;':''">
        {{ item.showPoup ? '' : item.text }}

        <!-- 我的消息 -->
        <message-box v-if="item.showMessage"></message-box>

        <el-popover v-if="item.showPoup" placement="bottom" width="200" trigger="hover" popper-class="official_account">
          <div class="content">
            <div class="img">
              <img :src="`${baseUrl}/static/defaults/mice_gongzhonghao.jpg`" alt="" />
            </div>
            <div class="text">
              <p>米测MeLab公众号</p>
              <span>扫码关注可了解更多详情</span>
            </div>
          </div>
          <span slot="reference">{{ item.text }}</span>
        </el-popover>


      </div>
    </div>
    <complainDialog :visible="showComplainDialog" @closeDialog="closeDialog"></complainDialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { getRecords } from "@/api/member/member";
import MessageBox from '@/components/messageBox.vue'
import { checkLogin, userCount } from "@/tool";
import complainDialog from "./dialogComponents/complainDialog.vue";

export default {
  components: { complainDialog, MessageBox },

  computed: {
    ...mapState("user", ["userInfo", "recordsInfo"]),
  },
  data() {
    return {
      activeView: '',
      showComplainDialog: false,
      tabs: [
        // { text: '纳米商城', path: '/nmMaterial',clickIgnore: true },
        // { text: '新手指引', path: '/guideView'},
        { text: '纳米商城', path: '/nmMaterial',open:'http://mall.nanoer.net',clickIgnore: true },
        { text: '数据解析', path: '/dataAnalysis' },
        { text: '科学可视化', path: '/scientificVisualization' },
        { text: '米测MeLab VIP', path: '/applyVip' },
        { text: '合作加入', path: '/cooperate' },
        { text: '草稿箱', path: '/drafts' },
        { text: '', showMessage: true,clickIgnore: true },
        { text: '发布需求', path: '/releaseDemand' },
        { text: '关注公众号', showPoup: true, clickIgnore: true },
        { text: '新手指引', path: '/guideView'},
      ]
    };
  },
  created() {
    if (this.userInfo.role == 'BUYER' || !this.userInfo.role){
      this.tabs[3].text = '米测MeLab VIP'
      this.tabs[3].path = '/understandMember'
    }else {
      this.tabs[3].text = 'VIP中心'
      this.tabs[3].path = '/memberCenter'
    }
    if (checkLogin()) {
      // 获取浏览记录
      getRecords().then((res) => {
        this.setRecordsInfo(res.records);
      });
      // 获取用户信息
      // this.getUserInfo();
    }
  },

  methods: {
    ...mapActions("user", ["logout"]),
    ...mapMutations("user", ["setRecordsInfo", "setUserInfo", "clearUserInfo", "resetToken"]),
    showDialog() {
      this.showComplainDialog = true;
      this.showCustomer = false;
      this.showGZH = false;
      userCount("投诉建议");
    },
    toDetail(item) {
      switch (item.type) {
        case "TEST_INSTRUMENT":
          this.$router.push(`/details/${item.objId}`);
          break;
      }
    },
    closeDialog() {
      this.showComplainDialog = false;
    },
    // 点击下拉列表
    handleCommand(command) {
      // 退出登录
      if (command == "logout") {
        this.$confirm("确定要退出登录吗？", "提示").then(() => {
          this.logout().then(() => {
            this.$message({ type: "success", message: "退出登录成功" });
            this.clearUserInfo({}); // 更新vuex
            this.resetToken();
            this.$router.push("/Login");
          });
        });
      } else if (command == "myCenter") {
        this.$router.push("/myCenter/centerHome");
      } else if (command == "myInvoice") {
        this.$router.push("/myCenter/invoiceInfoAdmin");
      } else if (command == "memberCenter") {
        // 判断是不是会员
        console.log(this.userInfo.role);
        const { role } = this.userInfo;
        if (role && role.includes("BUYER_VIP")) {
          // 是会员 去会员中心页面
          this.$router.push("/memberCenter");
        } else {
          // 不是会员  去了解会员页面
          this.$router.push("/understandMember");
        }
      }
    },
    // 跳转登录页面
    toLogin() {
      this.$router.push("/Login");
    },
    // 跳转注册页面
    toRegister() {
      this.$router.push("/Register?type=0");
    },
    toView(item) {
      if (item.clickIgnore) {
        if (item.open){
          window.open(item.open)
        }
        return
      }
      this.$router.push(item.path);
      // this.activeView = item.path
    },
  },
};
</script>

<style lang="less" scoped>


.browse_records {
  width: auto !important;
  max-width: 780px;

  .content {
    background-color: #fff;

    .goods_list {
      display: flex;
      height: 170px;

      .list_item {
        width: 195px;
        position: relative;
        cursor: pointer;

        .img {
          padding: 0 42px;
          margin-bottom: 8px;
          height: 112px;

          img {
            width: 112px;
            height: 112px;
          }
        }

        .text {
          display: flex;
          padding: 0 30px;
          justify-content: space-between;
          font-weight: 700;
          align-items: center;

          .name {
            color: #616161;
            font-size: 14px;
          }

          .price {
            flex-shrink: 0;
            color: @main-color;
            font-size: 12px;
          }
        }

        .right_line {
          width: 1px;
          height: 80px;
          background-color: #acacac;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .list_item:last-of-type {
        .right_line {
          display: none;
        }
      }
    }

    .none {
      text-align: center;
    }
  }
}

.Topbar {
  width: 100%;
  height: 30px;
  background: #23212A;
  font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
  font-weight: normal;
  font-size: 13px;
  color: #FFFFFF;
  line-height: 19px;
  text-align: left;
  font-style: normal;
  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 1000;
  .tools {
    width: 100%;
    height: 100%;
    // padding: 0 30px;
    background: #23212A;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .tools_item {
      cursor: pointer;
      margin-right: 40px;
      //font-weight: 600;

      &:hover {
        color: #6742D6;
      }

    }

    .tools_item:last-child {
      margin-right: 0;
    }

    .tools_item_active {
      color: #6742D6;
    }
  }

  ul {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    li {
      line-height: 80px;
      list-style: none;
      cursor: pointer;
      margin-right: 70px;
      // li:last-child{
      //   margin-right: 400px;
      // }
    }
  }


}

.vip_center {
  height: 100%;
  line-height: 40px;
  position: relative;

  &:hover {
    .list {
      display: block;
    }
  }

  .list {
    display: none;
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    color: #616161;
    width: 160px;
    border: 1px solid #cdcdcd;
    z-index: 77;

    // border-radius: 4px;
    p {
      height: 33%;
      line-height: 30px;
      text-align: center;
      border-bottom: 1px solid #cdcdcd;
    }

    p:last-child {
      border-bottom: 0;
    }
  }
}

.official_account {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .img {
      width: 112px;
      height: 112px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      text-align: center;

      p {
        margin-top: 4px;
        font-size: 14px;
      }

      span {
        font-size: 12px;
      }
    }
  }
}

.el-dropdown-link {
  color: #fff;
}

.login_box {
  display: flex;

  .vertical {
    margin: 0 10px;
  }

  .login_btn,
  .register_btn {
    cursor: pointer;
  }
}

.official_account {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .img {
      width: 112px;
      height: 112px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      text-align: center;

      p {
        margin-top: 4px;
        font-size: 14px;
      }

      span {
        font-size: 12px;
      }
    }
  }
}
</style>
